/*
 * Public API Surface of ngx-editor
 */

export * from './lib/editor.component';
export * from './lib/modules/menu/menu.component';
export * from './lib/modules/menu/floating-menu/floating-menu.component';
export * from './lib/editor.module';
export * from './lib/editor.service';

export * from './lib/schema';
export * from './lib/validators';

export * from './lib/types';
export * from './lib/parsers';
export { default as Editor } from './lib/Editor';
export * from './lib/defaultPlugins';

// other exports for convenience
export { ImageViewComponent } from './lib/components/image-view/image-view.component';
